module.exports = __webpack_public_path__ + "img/auth-pic.62b383b8.jpg";